/**
 * Supported Document Type
 */
export enum DocumentType {
  APS = 'APS',
  EHR = 'EHR',
  ETI = 'ETI',
  MEDEXAM_LABS = 'MEDEXAM_LABS',
  MEDEXAM_PM = 'MEDEXAM_PM',
  MEDEXAM_EKG = 'MEDEXAM_EKG',
  OTAF_LETTER = 'OTAF_LETTER',
  DECLINE_LETTER = 'DECLINE_LETTER',
  REINSTATEMENT_APPROVAL_LETTER = 'REINSTATEMENT_APPROVAL_LETTER',
  REINSTATEMENT_DECLINE_LETTER = 'REINSTATEMENT_DECLINE_LETTER',
  REINSTATEMENT_WITHDRAWN_LETTER = 'REINSTATEMENT_WITHDRAWN_LETTER',
  REINSTATEMENT_APPLICATION = 'REINSTATEMENT_APPLICATION',
  TRL = 'TRL',
  MVR = 'MVR',
  MIB = 'MIB',
  DISCLOSURE = 'DISCLOSURE',
  RX = 'RX',
  LAB_PIQTURE = 'LAB_PIQTURE',
  MEDICAL_CLAIMS = 'MEDICAL_CLAIMS',
  SCRIPT_CHECK = 'SCRIPT_CHECK',
  MIB_CODE_DETAILS = 'MIB_CODE_DETAILS',
  INSURANCE_LABS = 'INSURANCE_LABS',
  CRIMINAL_RECORDS = 'CRIMINAL_RECORDS',
  SUBSTANDARD_LETTER = 'SUBSTANDARD_LETTER',
  ADDITIONAL_INFORMATION_FROM_CUSTOMER = 'ADDITIONAL_INFORMATION_FROM_CUSTOMER',
  CARRIER_ELIGIBILITY = 'CARRIER_ELIGIBILITY',
  SPECIAL_AUTHORIZATION = 'SPECIAL_AUTHORIZATION',
  PLAN_F = 'PLAN_F',
  RULE_REVIEW = 'RULE_REVIEW',
  AUTO_MEDICAL_CLAIMS = 'AUTO_MEDICAL_CLAIMS',
  PIA_REPORT = 'PIA_REPORT',
  RUW_WITHDRAWL_LETTER = 'RUW_WITHDRAWL_LETTER',
  DISPUTE = 'DISPUTE',
  ADDITIONAL_DOCUMENTS = 'ADDITIONAL_DOCUMENTS',
}
